var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRankList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1007_13592",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1007_13592)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 23.3327V22.166H5.83333V21.5827H4.66667V20.416H5.83333V19.8327H3.5V18.666H7V23.3327H3.5ZM9.33333 22.166V19.8327H24.5V22.166H9.33333ZM3.5 16.3327V15.2827L5.6 12.8327H3.5V11.666H7V12.716L4.9 15.166H7V16.3327H3.5ZM9.33333 15.166V12.8327H24.5V15.166H9.33333ZM4.66667 9.33268V5.83268H3.5V4.66602H5.83333V9.33268H4.66667ZM9.33333 8.16602V5.83268H24.5V8.16602H9.33333Z",
    fill: "#A37C51"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankList);
export default __webpack_public_path__ + "static/media/rankList.a566e0a9ee4f9501c36f352a26072a06.svg";
export { ForwardRef as ReactComponent };